export default __webpack_public_path__ + "static/media/BA8.ed3ebfec.jpg";